import React, { useEffect, useState } from 'react';
import AdminHeader from 'src/globals/Layout/Admin/AdminHeader';
import TPortafolioMyOrganizations from './TPortafolioMyOrganizations';
import { connect } from 'react-redux';
import { getParentOrganizationsByUser, getAllOrganization, getOrganizationsByParentOrganizationId } from 'src/store/organization/thunks';
import { AppState } from 'src/store';
import TPortafolioOrganizations, { DataTypePortafolio } from './TPortafolioOrganizations';
import TActivityDataPortfolio from './TActivityDataPortfolio';
interface TPortafolioGeiProps {   
    getAllOrganization?: any;   
    getOrganizationsByParentOrganizationId?:any; 
    getParentOrganizationsByUser? : any;
}

const TPortafolioGei: React.FC<TPortafolioGeiProps> = (props: TPortafolioGeiProps) =>{
    const [dataTable, setDataTable] = useState([]);
        const [showTable, setShowTable] = useState(true);
        const [showTables, setShowTables] = useState("");
        const [organizationObject, setOrganizationObject] = useState<DataTypePortafolio>();
        const [showEdit , setShowEdit] = useState(true);
        const init = async () => {               
               const responseDataOrganization = await props.getParentOrganizationsByUser();
               
                  setShowTable(true);
                   setDataTable(responseDataOrganization);
                   setOrganizationObject(responseDataOrganization[0]);
             
           }
           useEffect(() => {
               init();
           }, []);
       return (
           <div>
               {/* {showTable ?  */}
               <>
                 <AdminHeader>Mis Organizaciones</AdminHeader>
                 <TPortafolioMyOrganizations dataTableOrganization={dataTable} editView={true}/>
               </>
               {/* :<>
                 
                 <TPortafolioOrganizations organizationsTable={showTables} organizationObject={organizationObject} editView={showEdit}  />
               
               </>
               
               }
              */}
               
           </div>
   
       );
};

const mapStateToProps = (state: AppState) => ({

});

export default connect(mapStateToProps, {  
    getAllOrganization, getOrganizationsByParentOrganizationId,getParentOrganizationsByUser
})(TPortafolioGei);